module.exports = __webpack_public_path__ + "8b610cc10bfcab63b369b5d17fc24d79.svg";